var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarningOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94751,
    width: 42.7463,
    height: 42.7463,
    rx: 5.34328,
    fill: "#C4FFE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6075 16C23.0475 14.82 21.8475 14 20.4475 14H15.9475V12H27.9475V14H24.6875C25.1675 14.58 25.5275 15.26 25.7375 16H27.9475V18H25.9275C25.6775 20.8 23.3175 23 20.4475 23H19.7175L26.4475 30H23.6775L16.9475 23V21H20.4475C22.2075 21 23.6675 19.7 23.9075 18H15.9475V16H23.6075Z",
    fill: "#0DA06A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningOne);
export default __webpack_public_path__ + "static/media/earning-one.46b13137434839fa13380c9b1eb4e722.svg";
export { ForwardRef as ReactComponent };